import React, { FC, MouseEventHandler } from 'react';
import { setClass } from '@utils';
import { PropsWithChildren } from 'react';
import '../../styles/components/svg.scss';

interface SvgWraperProps {
  divClassName?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const SvgWrapper: FC<PropsWithChildren<SvgWraperProps>> = ({ children, onClick, divClassName }) => (
  <div 
    className={setClass(onClick && 'clickable', 'svg') + divClassName ?? ''}
    onClick={onClick}
  >
    {children}
  </div>
);